<template>
	<div class="landing-page terms">

		<!-- Top navbar -->
		<landing-page-navbar></landing-page-navbar>
		<div class="content-container">
			<div class="content">

				<div class="container" v-if="carrierDetails">
					<div class="row">
						<div class="col-md-10 col-lg-8">
							<dd v-if="carrierDetails.termsLink">
								<span v-html="carrierDetails.termsLink"></span>
							</dd>
							<dd v-else>
								<div class="terms">
									<div class="header">
										<h1>TERMS AND CONDITIONS OF SUPPLY</h1>
									</div>

									<div class="contain">

										<hr>

										<div v-if="countryCodeSetting === 'AU'">
											<a target="_blank" href="https://likewize-files.s3.eu-west-2.amazonaws.com/au/documents/Likewize_Repair_Terms_And_Conditions_Of_Supply_App.pdf">Click to see our terms and conditions of supply</a> <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/pdf_32x32.png" alt="Adobe">
										</div>

                                        <hr>

									</div>
								</div>

							</dd>
						</div>
					</div>
				</div>
			</div>
		</div>


		<!-- Footer -->
		<page-footer></page-footer>
	</div>
</template>

<script>
if (process.env.VUE_APP_PARTNER_ENVIRONMENT) {
	require('@/styles/core/whitelabel/'+process.env.VUE_APP_PARTNER_ENVIRONMENT+'.scss');
} else {
	require('@/styles/core/whitelabel/wefix.scss');
}

import {mapGetters} from "vuex";

export default {
	name: "AppTermsIndex",

	computed: {
		...mapGetters([
			'carrierDetails',
			'countryCodeSetting'
		])
	},

    mounted() {
        if (this.countryCodeSetting !== 'AU') {
            this.$router.push({name: 'TermsIndex' });
        }
    }
}
</script>

<style scoped>

</style>